"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tabs = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _context = require("./context");

var _core = require("@emotion/core");

const propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   The current index from active tab.
  */
  activeIndex: _propTypes.number,

  /**
   The display content of the tabs with the following components: `TabList`, `TabItem`, `TabsPanel` and `Tab`.
  */
  children: _propTypes.node.isRequired,

  /**
   The callback to be executed when tab is changed.
  */
  onTabChange: _propTypes.func
} : {};
const defaultProps = {
  activeIndex: 0,
  onTabChange: () => {}
};

const Tabs = ({
  activeIndex,
  onTabChange,
  children,
  ...props
}) => {
  return (0, _core.jsx)(_context.TabsContext.Provider, {
    value: {
      activeIndex,
      onTabChange,
      ...props
    }
  }, children);
};

exports.Tabs = Tabs;
process.env.NODE_ENV !== "production" ? Tabs.propTypes = propTypes : void 0;
Tabs.defaultProps = defaultProps;
Tabs.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Tabs",
  "props": {
    "activeIndex": {
      "defaultValue": {
        "value": "0",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "The current index from active tab."
    },
    "onTabChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "The callback to be executed when tab is changed."
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": true,
      "description": "The display content of the tabs with the following components: `TabList`, `TabItem`, `TabsPanel` and `Tab`."
    }
  }
};